/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Company } from '../models/Company';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CompanyEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Supports lookup by multiple fields by setting `lookup_fields`.
   *
   * Example:
   * ```
   * lookup_fields = ['id', 'slug']
   * ```
   * @returns Company
   * @throws ApiError
   */
  public companyRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this company.
     */
    id: string,
  }): CancelablePromise<Company> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/company/{id}/',
      path: {
        'id': id,
      },
    });
  }

}
